'use strict';

angular.module('AcaApp').factory('NotificationsService',
  [
    'NotificationsResource',
    function(NotificationsResource){
      return{
        Notifications: function(){
          var rpcConfig = {method: 'Notifications', params: []};
          return NotificationsResource.executeRpc(rpcConfig).$promise;
        }
      };
    }
  ]);